import store from '../store'
export const MapsInit = () => {
  store.dispatch('setLocationService', new window.google.maps.places.AutocompleteService())
}
